import React from 'react'
import { Grid } from '@material-ui/core'
import NewPriceFlow from './Price/NewPriceFlow'

const DetailPrice = (props) => {
  return (
    <Grid container>
      <NewPriceFlow {...props} />
    </Grid>
  )
}

export default DetailPrice
